export default {
      id: "ic_default_bilyoner_logo-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_default_bilyoner_logo-usage",
      toString: function () {
        return this.url;
      }
    }